import { gql } from 'Utils/apolloClient'

const translatesFragment = gql`
  fragment translateFragment on Translates {
    messages(keys: $keys)
  }`

export default translatesFragment
